/**
 * Whether the organisation withholds saving this order item, for the save button in
 * orderItem-edit (C2027-196, §5.4). An order item without an `order` is still to be created;
 * one with an `order` is being edited.
 */
export function isOrderSaveForbidden(
  isBatch: boolean,
  orderItem: { order?: unknown } | null | undefined,
  batchOrderItems: { order?: unknown }[] | null | undefined,
  canCreateOrder: boolean,
  canEditOrder: boolean,
): boolean {
  if (isBatch) {
    const items = batchOrderItems || [];
    const hasNew = items.some((item) => !item.order);
    const hasExisting = items.some((item) => !!item.order);
    return (hasNew && !canCreateOrder) || (hasExisting && !canEditOrder);
  }
  if (!orderItem || !orderItem.order) {
    return !canCreateOrder;
  }
  return !canEditOrder;
}

/**
 * Whether the blocked action is "edit" (an order already exists) rather than "create", for the
 * forbidden-action message in orderItem-edit. Mirrors isOrderSaveForbidden's own create/edit split
 * instead of the component's `edited` flag, which is true as soon as an order item row exists, even
 * when it has no order yet (C2027-196).
 */
export function isExistingOrder(
  isBatch: boolean,
  orderItem: { order?: unknown } | null | undefined,
  batchOrderItems: { order?: unknown }[] | null | undefined,
): boolean {
  if (isBatch) {
    const items = batchOrderItems || [];
    return items.some((item) => !!item.order);
  }
  return !!(orderItem && orderItem.order);
}
